<template>
  <div v-if="teams.length" class="team-grid grid-x grid-margin-x small-up-3 medium-up-5 large-up-6">
    <TeamBlock v-for="team in teams" :key="team.id" :team="team" class="cell" />
  </div>
  <p v-else v-html="$t('noTeams')" class="no-teams" />
</template>

<script>
  import i18n from './locales'
  import TeamBlock from '~/modules/teams/components/frontend/team-block'

  export default {
    name: 'TeamGrid',
    i18n,
    components: {
      TeamBlock,
    },
    props: {
      teams: {
        type: Array,
        default: () => ([]),
      },
    },
  }
</script>

<style lang="scss" scoped>
  .team-grid {
    .team-block {
      margin-bottom: 2rem;
    }
  }
  .no-teams {
    font: {
      style: italic;
      weight: bold;
    }
    margin-top: 2rem;
    text-align: center;
  }
</style>

